import api from '../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'
import { changeBodyToForm } from "../../../utils"
import { GET_SALES, GET_SALE, CHANGE_SALE_STATUS } from "./actionTypes";
import { GET_SALES_SUCCESS, GET_SALE_SUCCESS, CHANGE_SALE_STATUS_SUCCESS } from "./mutationTypes"



const state = {
    sales: {},
    ids: [],
    isLoading: false
}

const saleStatuses = {
    'rejected': 1,
    'verified': 2,
    'pending': 3,
    'notVerified': 4,
    'all': 5
}

const getters = {
    salesIds: (state) => state.ids,
    salesArray: (state) => state.ids.map(id => ({
        ...state.sales[id],
        ["ticket_user"]: {
            ...state.sales[id]["ticket_user"],
            fullName: state.sales[id]["ticket_user"].name + ' ' + (state.sales[id]["ticket_user"].lastname == "Not set" ? '' : state.sales[id]["ticket_user"].lastname)
        }
    })), 
    singleSale: state => id => console.log(state, id) || state.sales[id]
}

const mutations = {
    [GET_SALES_SUCCESS](state, { ids, data }) {
        state.ids = ids
        state.sales = { ...state.sales, ...data }
    },
    [GET_SALE_SUCCESS](state, { data }) {
        state.sales = { ...state.sales, [data.id]: data }
    },
    [CHANGE_SALE_STATUS_SUCCESS](state, { id, value }) {
        
        state.sales[id].status = value + 1 
        //value + 1 works because the status sent to the server is not the same as the status of the bill,
    }
}

const actions = {
    async [GET_SALES]({ commit }, status) {
        console.log(status)
        Nprogress.start();
        try {
            const { data } = await api.get(`ticket/ticket-bills?opt=${saleStatuses[status]}`)
            commit(GET_SALES_SUCCESS, data)
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    },
    async [GET_SALE]({ commit }, id) {
        Nprogress.start();
        try {
            const { data } = await api.get(`ticket/ticket-bills/${id}`)
            console.log(data)
            commit(GET_SALE_SUCCESS, data)
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    },
    async [CHANGE_SALE_STATUS]({ commit }, { id, value }) {
        Nprogress.start();
        try {
            const { data } = await api.put(`ticket/ticket-bills/${id}`, { opt: value })
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ ${data.message}`
            })
            console.log(data, id, value)
            commit(CHANGE_SALE_STATUS_SUCCESS, { id, value })
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    }
}

const somethingWentWrong = (err) => {
    console.table(err.data)
    Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
    })
}

export default {
    state,
    getters,
    mutations,
    actions
}
